import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Card,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import { UseMenuContent } from "./UseMenuContent";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { FileUploader } from "react-drag-drop-files";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditMenu(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getMenuByID, validate, updateMenu, RemoveMenuAdv, addMenuAdv } =
    UseMenuContent();
  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    rowIndex: undefined,
    url: undefined,
    advertisements: [],
  });
  const { isSmall } = useBreakpoints();

  const [url1, setUrl1] = useState();
  const [url2, setUrl2] = useState();
  const [url3, setUrl3] = useState();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getMenuByID(location.state.id, (menuRes) => {
        setImgState({ ...imgState, url: menuRes.icon });
        setUrl1(
          menuRes.advertisements.length > 0 &&
            menuRes.advertisements.find((model) => model.rowIndex == 1)
            ? menuRes.advertisements.find((model) => model.rowIndex == 1).url
            : ""
        );
        setUrl2(
          menuRes.advertisements.length > 0 &&
            menuRes.advertisements.find((model) => model.rowIndex == 2)
            ? menuRes.advertisements.find((model) => model.rowIndex == 2).url
            : ""
        );
        setUrl3(
          menuRes.advertisements.length > 0 &&
            menuRes.advertisements.find((model) => model.rowIndex == 3)
            ? menuRes.advertisements.find((model) => model.rowIndex == 3).url
            : ""
        );
        setState({
          id: menuRes.id,
          title: menuRes.title,
          rowIndex: menuRes.rowIndex,
          url: menuRes.url,
          advertisements: menuRes.advertisements,
        });
      });
    }
  }, []);

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const [sendModelADV, setSendModelADV] = useState({
    id: 0,
    menuID: location.state.id,
    url: "/assd",
    rowIndex: undefined,
  });

  const [oneFile, setOneFile] = useState(undefined);

  const handleChangeImage1 = (file, rowIndex, ADVID) => {
    var urlForSend;
    if (rowIndex == 1) {
      urlForSend = url1;
    } else if (rowIndex == 2) {
      urlForSend = url2;
    } else if (rowIndex == 3) {
      urlForSend = url3;
    }
    setOneFile(file[0]);
    setSendModelADV({
      ...sendModelADV,
      rowIndex: rowIndex,
      url: urlForSend,
      id: ADVID ? ADVID : 0,
    });
  };

  useEffect(() => {
    var urlForSend = "";
    if (sendModelADV.rowIndex == 1) {
      urlForSend = url1;
    } else if (sendModelADV.rowIndex == 2) {
      urlForSend = url2;
    } else if (sendModelADV.rowIndex == 3) {
      urlForSend = url3;
    }
    setSendModelADV({
      ...sendModelADV,
      url: urlForSend,
    });
  }, [url1, url2, url3]);

  useEffect(() => {
    if (oneFile) {
      addMenuAdv(sendModelADV, oneFile, () => {
        setOneFile(undefined);
        getMenuByID(state.id, (menuRes) => {
          setImgState({ ...imgState, url: menuRes.icon });
          setUrl1(
            menuRes.advertisements.length > 0 &&
              menuRes.advertisements.find((model) => model.rowIndex == 1)
              ? menuRes.advertisements.find((model) => model.rowIndex == 1).url
              : ""
          );
          setUrl2(
            menuRes.advertisements.length > 0 &&
              menuRes.advertisements.find((model) => model.rowIndex == 2)
              ? menuRes.advertisements.find((model) => model.rowIndex == 2).url
              : ""
          );
          setUrl3(
            menuRes.advertisements.length > 0 &&
              menuRes.advertisements.find((model) => model.rowIndex == 3)
              ? menuRes.advertisements.find((model) => model.rowIndex == 3).url
              : ""
          );
          setState({
            id: menuRes.id,
            title: menuRes.title,
            rowIndex: menuRes.rowIndex,
            url: menuRes.url,
            advertisements: menuRes.advertisements,
          });
        });
      });
    }
  }, [oneFile]);

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/menues" },
          { name: "ویرایش منو", url: "/menues/editMenu" },
        ],
      }}
    >
      {state.title ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ mt: 1, width: "100%" }}
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="نام منو"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              sx={{ mt: 1, width: "100%", input: { direction: "rtl" } }}
              value={state.url ? state.url : ""}
              error={errorState.url}
              label="آدرس منو"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, url: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 5"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Typography variant="subtitle2" sx={{ mr: 1 }}>
              آیکن منو :
            </Typography>
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "70px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 2,
                      border: "2px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url
                          ? imgState.url
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box gridColumn="span 12">
            <Typography variant="subtitle2">آگهی‌های منو :</Typography>
          </Box>
          {[1, 2, 3].map((rowIndex, i) => {
            let url =
              state.advertisements &&
              state.advertisements.find((model) => model.rowIndex == rowIndex)
                ? state.advertisements.find(
                    (model) => model.rowIndex == rowIndex
                  ).image
                : "/static/img/nobanner.jpg";
            var ADVID =
              state.advertisements.length > 0 &&
              state.advertisements.find((model) => model.rowIndex == rowIndex)
                ? state.advertisements.find(
                    (model) => model.rowIndex == rowIndex
                  ).id
                : "";
            var textUrl;
            if (rowIndex == 1) {
              textUrl = url1;
            } else if (rowIndex == 2) {
              textUrl = url2;
            } else if (rowIndex == 3) {
              textUrl = url3;
            }
            return (
              <Box
                gridColumn={isSmall ? "span 12" : "span 4"}
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <FileUploader
                  multiple={true}
                  handleChange={(evt) =>
                    handleChangeImage1(evt, rowIndex, ADVID)
                  }
                  name="file"
                  types={fileTypes}
                  children={
                    <Box sx={{ width: "100%" }}>
                      <Card
                        sx={{
                          width: "100%",
                          height: "200px",
                          p: 2,
                          border: "2px",
                          borderStyle: "dashed",
                          borderColor: "secondary.main",
                          borderRadius: 4,
                          boxShadow: 0,
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                      >
                        <CardMedia
                          component="img"
                          sx={{ width: "100%", height: "100%" }}
                          image={url}
                        />
                      </Card>
                    </Box>
                  }
                />
                <TextField
                  sx={{ my: 3, input: { direction: "rtl" } }}
                  value={textUrl ? textUrl : ""}
                  error={errorState.url}
                  label="آدرس آگهی"
                  size="small"
                  variant="outlined"
                  onChange={(evt) => {
                    if (rowIndex == 1) {
                      setUrl1(evt.target.value);
                    } else if (rowIndex == 2) {
                      setUrl2(evt.target.value);
                    } else if (rowIndex == 3) {
                      setUrl3(evt.target.value);
                    }

                    setSendModelADV({
                      ...sendModelADV,
                      rowIndex: rowIndex,
                      id: ADVID ? ADVID : 0,
                    });
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Box sx={{ mx: "auto" }}>
                  <IconButton
                    onClick={() => {
                      setProgress(true);
                      RemoveMenuAdv(ADVID, () => {
                        getMenuByID(location.state.id, (menuRes) => {
                          setImgState({ ...imgState, url: menuRes.icon });
                          setUrl1(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 1
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 1
                                ).url
                              : ""
                          );
                          setUrl2(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 2
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 2
                                ).url
                              : ""
                          );
                          setUrl3(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 3
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 3
                                ).url
                              : ""
                          );
                          setState({
                            id: menuRes.id,
                            title: menuRes.title,
                            rowIndex: menuRes.rowIndex,
                            url: menuRes.url,
                            advertisements: menuRes.advertisements,
                          });
                        });
                      });
                    }}
                    variant="contained"
                  >
                    <DeleteIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setProgress(true);
                      addMenuAdv(sendModelADV, oneFile, () => {
                        setOneFile(undefined);
                        setProgress(false);
                        getMenuByID(state.id, (menuRes) => {
                          setImgState({ ...imgState, url: menuRes.icon });
                          setUrl1(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 1
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 1
                                ).url
                              : ""
                          );
                          setUrl2(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 2
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 2
                                ).url
                              : ""
                          );
                          setUrl3(
                            menuRes.advertisements.length > 0 &&
                              menuRes.advertisements.find(
                                (model) => model.rowIndex == 3
                              )
                              ? menuRes.advertisements.find(
                                  (model) => model.rowIndex == 3
                                ).url
                              : ""
                          );
                          setState({
                            id: menuRes.id,
                            title: menuRes.title,
                            rowIndex: menuRes.rowIndex,
                            url: menuRes.url,
                            advertisements: menuRes.advertisements,
                          });
                        });
                      });
                    }}
                    variant="contained"
                  >
                    <CheckCircleIcon />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateMenu(state, imgState.file, () => {
                    navigate("/menues", {
                      state: location.state,
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/menues", {
                  state: location.state,
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}></Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
